import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { DataSharingService } from './data-sharing.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

declare var startRecording;


@Injectable({
  providedIn: 'root'
})
export class WebSocketService {

  socket: any;

  latitude: string = "";
  longitude: string = "";

  videoCallObj = {};
  webSocketSetInterval = null;


  LocationUser$ = new Subject();
  constructor(private dataSharingSrvc: DataSharingService) {
    this.initWebSocket();
    // this.LocationUser = this.LocationSubject.asObservable();

  }

  initWebSocket() {

    this.latitude = "";
    this.longitude = "";

    console.log("________initWebsocket_______");

    this.socket = io(this.dataSharingSrvc.apiUrl[this.dataSharingSrvc['environment']]['webSocketUrl']); //Connect to Socket

    this.socket.on('disconnect', msg => {
      console.log("Web socket disconnect : ", msg);
    });

    this.socket.on('error', msg => {
      console.log("Web socket error : ", msg);
    });

    this.socket.on('', msg => {
      if (msg) {

        let splittedArr = (msg as string).split(",");

        const autoId = splittedArr[2];
        console.log('getremoteuserloc', msg, splittedArr);

        if (autoId == this.dataSharingSrvc["autoId"]) {
          this.latitude = splittedArr[0];
          this.longitude = splittedArr[1];
          this.LocationValue = { latitude: this.latitude, longitude: this.longitude };
          if (this.webSocketSetInterval) {
            clearInterval(this.webSocketSetInterval);
          }
        }

        // console.log("getremoteuserloc message arrived : ", msg);

        // setTimeout(() => {
        //   console.log("*************startRecording**************");
        //   startRecording(this.videoCallObj['appId'], this.videoCallObj['token'], this.videoCallObj['channel']);
        // }, 3000);
      }
    });
    this.socket.on('getremoteuserloc',msg=>{
      if (msg) {

        let splittedArr = (msg as string).split(",");

        const autoId = splittedArr[2];
        console.log('getremoteuserloc topic', msg, splittedArr);

        if (autoId == this.dataSharingSrvc["autoId"]) {
          this.latitude = splittedArr[0];
          this.longitude = splittedArr[1];
          this.LocationValue = { latitude: this.latitude, longitude: this.longitude };
          if (this.webSocketSetInterval) {
            clearInterval(this.webSocketSetInterval);
          }
        }
      }
    })
  }

  sendLatLongtoBackend(latLongStr) {
    this.socket.emit("remoteuserlocation", latLongStr);
  }

  private set LocationValue(data) {
    this.LocationUser$.next(data);
  }

  sendLatLongToServerUntilVideoCallerReceiveIt(currPos) {
    this.webSocketSetInterval = setInterval(() => {
      this.sendLatLongtoBackend(currPos);
    }, 1000)
  }
}
